import Endpoints from "../constants/Endpoints";
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from "../libs/RestRequest";
import isResponseValid from "../libs/isResponseValid";
import reduxStore from "../redux/store";
import {clearResource, setResource, setSaveStatusDialog, setSaveStatusError, setSaveStatusLoading, setStepperState} from "../redux/actions";
import Tr from "../translations/Translations";

const BZP_CONTRACT_NOTICE_STATUS = 'bzpContractNoticeStatus';

const showError = (message) => {
	reduxStore.dispatch(setSaveStatusError(message))
}

const getContractNotice = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}
const deleteLastContractNoticeVersion = async (demandId) => {
	try {
		const resp = await RestRequestDELETE(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE(demandId));
		return isResponseValid(resp, showError);
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const createNewContractNoticeVersion = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_CREATE_NEW_VERSION(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractNoticeDynamicDictionaries = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_DYNAMIC_DICTIONARIES(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractNoticeTranslations = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_TRANSLATIONS(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractNoticeDictionaries = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_DICTIONARIES(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const saveContractNoticeDraft = async (demandId, form) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_DRAFT(demandId), form);
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const saveContractNotice = async (demandId, form) => {
	try {
		return await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE(demandId), form);
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const publishContractNotice = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const rollbackContractNotice = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_ROLLBACK(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const publishContractNoticeUpdate = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_UPDATE(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const rollbackContractNoticeUpdate = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_UPDATE_ROLLBACK(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const saveContractNoticeSection = async (demandId) => {
	reduxStore.dispatch(setSaveStatusLoading());

	try {
		reduxStore.dispatch(setSaveStatusDialog());
		reduxStore.dispatch(setStepperState());
		//await validateSection(DemandValidation.NATIONAL_NOTICE, demandId);
	} catch (error) {
	}
}

const printDemandNoticePreview = async (demandId) => {
	try {
		await RestRequestBLOB(Endpoints.NOTICE_DOWNLOAD_PREVIEW(demandId));
	} catch (e) {
		console.error(e);
	}
}

const getContractNoticeStatus = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_STATUS(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractModificationNoticeStatus = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_MODIFICATION_NOTICE_STATUS(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const checkContractNoticeStatus = async (demandId) => {
	try {
		const resp = await RestRequestPUT(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_STATUS(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const validate = (id) => {
	return RestRequestGET(Endpoints.NATIONAL_NOTICE_VALIDATE(id));
}

const clearResources = (id) => reduxStore.dispatch(clearResource(id));

export default {
	getContractNotice,
	getContractNoticeTranslations,
	getContractNoticeDictionaries,
	getContractNoticeDynamicDictionaries,
	saveContractNoticeSection,
	saveContractNotice,
	saveContractNoticeDraft,
	printDemandNoticePreview,
	publishContractNotice,
	getContractNoticeStatus,
	getContractModificationNoticeStatus,
	checkContractNoticeStatus,
	clearResources,
	validate,
	createNewContractNoticeVersion,
	publishContractNoticeUpdate,
	deleteLastContractNoticeVersion,
	rollbackContractNotice,
	rollbackContractNoticeUpdate,
	BZP_CONTRACT_NOTICE_STATUS
};
